/*
  Overe countdown
  ---------------
  Drives every [data-overe-countdown] element on the page.

  Each timer carries data-deadline as an ISO8601 string WITH an explicit
  offset (e.g. 2026-08-13T21:30:00+10:00) so it resolves to the same instant
  in every visitor timezone. Never rely on the shop timezone here.

  Timers render hidden (data-countdown-idle) and are revealed once a valid
  deadline is parsed, so a JS failure leaves the static deadline copy rather
  than a frozen 00:00 that reads as broken.

  On expiry the closest [data-overe-offer] gets .is-expired, which is what
  swaps the live band for the closed message. All hiding is CSS.
*/
(function () {
  'use strict';

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function setUnit(timer, unit, value) {
    var nodes = timer.querySelectorAll('[data-unit="' + unit + '"]');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].textContent !== value) nodes[i].textContent = value;
    }
  }

  function toggleBlock(timer, unit, show) {
    var blocks = timer.querySelectorAll('[data-unit-block="' + unit + '"]');
    for (var i = 0; i < blocks.length; i++) {
      blocks[i].classList.toggle('is-hidden', !show);
    }
  }

  function toggleHoursBlock(timer, show) {
    toggleBlock(timer, 'hours', show);
  }

  function expire(timer) {
    var offer = timer.closest('[data-overe-offer]');
    if (!offer || offer.classList.contains('is-expired')) return;
    offer.classList.add('is-expired');
    offer.dispatchEvent(new CustomEvent('overe:offer:expired', { bubbles: true }));
  }

  // Returns true while the timer is still running.
  // Timers that carry a [data-unit="days"] node get a days unit with residual
  // hours; timers without one keep the original hours-run-up behaviour, so
  // existing markup (e.g. overe-offer-hero) is unaffected.
  function tick(timer) {
    var remaining = timer.overeDeadline - Date.now();
    var hasDays = timer.querySelector('[data-unit="days"]') !== null;

    if (remaining <= 0) {
      toggleBlock(timer, 'days', false);
      toggleHoursBlock(timer, false);
      setUnit(timer, 'days', '0');
      setUnit(timer, 'hours', '00');
      setUnit(timer, 'minutes', '00');
      setUnit(timer, 'seconds', '00');
      expire(timer);
      return false;
    }

    var total = Math.floor(remaining / 1000);
    var hours = Math.floor(total / 3600);

    if (hasDays) {
      var days = Math.floor(total / 86400);
      hours = Math.floor((total % 86400) / 3600);
      toggleBlock(timer, 'days', days > 0);
      setUnit(timer, 'days', String(days));
      toggleHoursBlock(timer, days > 0 || hours > 0);
    } else {
      toggleHoursBlock(timer, hours > 0);
    }

    setUnit(timer, 'hours', pad(hours));
    setUnit(timer, 'minutes', pad(Math.floor((total % 3600) / 60)));
    setUnit(timer, 'seconds', pad(total % 60));
    return true;
  }

  function start() {
    var timers = Array.prototype.slice.call(document.querySelectorAll('[data-overe-countdown]'));
    if (!timers.length) return;

    var live = [];

    timers.forEach(function (timer) {
      var parsed = Date.parse(timer.getAttribute('data-deadline'));
      // A bad or missing date leaves the timer hidden and the static copy in place.
      if (isNaN(parsed)) return;

      timer.overeDeadline = parsed;
      timer.removeAttribute('data-countdown-idle');

      // Evaluate once immediately so anyone arriving after the deadline never
      // sees a live timer, not even for a frame.
      if (tick(timer)) live.push(timer);
    });

    if (!live.length) return;

    var interval = setInterval(function () {
      live = live.filter(tick);
      if (!live.length) clearInterval(interval);
    }, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
